import { caloTheme } from 'src/theme/calo';

import { Button } from '@mui/material';

interface ResendButtonProps {
  resendIn: string | null | 0;
  handleResend: () => void;
}

const ResendButton = ({ resendIn, handleResend }: ResendButtonProps) => (
  <Button
    sx={{
      mt: 2,
      mb: 2,
      borderColor: caloTheme.palette.primary500,
      color: caloTheme.palette.primary500,
      textTransform: 'none',
      '&:hover': {
        borderColor: caloTheme.palette.primary600,
        backgroundColor: caloTheme.palette.primary50
      },
      '&.Mui-disabled': {
        borderColor: caloTheme.palette.neutral200,
        color: caloTheme.palette.neutral500
      }
    }}
    variant="outlined"
    onClick={handleResend}
    disabled={!!resendIn}
  >
    {resendIn ? `Resend code in ${resendIn}` : 'Resend code'}
  </Button>
);

export default ResendButton;
